/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext } from "react";
import { connect } from "react-redux";
import { ThemeContext } from "styled-components";
import InfiniteScroll from "react-infinite-scroller";
import debounce from "lodash/debounce";
import Col from "../../UIcomponent/Column";
import LessonsList from "./LessonsList/LessonsList";
import LocalContext from "../../Context/LocalContetxt";
import { Loader } from "../../UIcomponent/Loader";
import actions from "../../redux/actions";

import "./Lessons.scss";

const Lessons = (props) => {
  const {
    fetchSessions,
    isFetching,
    data,
    activeTab,
    resetSessions,
    searchString,
    fromDate,
    toDate,
  } = props;
  const config = useContext(LocalContext).config;
  const lang = useContext(LocalContext).lang;
  const theme = useContext(ThemeContext);

  let params = {
    Page: 0,
    PageSize: 10,
    status: activeTab,
    Fullname: searchString,
    ...(fromDate && { DateTimeFrom: fromDate }),
    ...(toDate && { DateTimeTo: toDate }),
  };

  const commitSearch = debounce((role, params) => {
    fetchSessions(role, params);
  }, 500);

  useEffect(() => {
    resetSessions();
    fetchSessions(config.role, params);
  }, [activeTab]);

  useEffect(() => {
    resetSessions();
    commitSearch(config.role, params);
  }, [searchString]);

  const LoadMore = () => {
    if (!data.Paging.HasNext) {
      return;
    }

    params.Page = data.Paging.Page + 1;
    if (activeTab > 0) {
      params.status = activeTab;
    }
    fetchSessions(config.role, params);
  };

  return (
    <Col className="l__Lessons" xl={18} lg={18} md={23} sm={24} xs={24}>
      <Col
        className="w__Lessons__Section"
        xl={24}
        lg={24}
        md={24}
        sm={22}
        xs={22}
      >
        <InfiniteScroll
          className="infiniteScroll"
          threshold={30}
          pageStart={0}
          initialLoad={false}
          key="if-1"
          loadMore={LoadMore}
          hasMore={data && data.Paging ? data.Paging.HasNext : false}
          useWindow={true}
          loader={<Loader height={150} />}
        >
          <LessonsList
            noMore
            lang={lang}
            theme={theme}
            searchFetching={isFetching}
            data={data.Sessions}
          />
        </InfiniteScroll>
      </Col>
    </Col>
  );
};

const mapStateToProps = (state) => ({
  isFetching: state.dashboard.sessions.fetching,
  data: state.dashboard.sessions.data,
  activeTab: state.dashboard.status.activeTab,
  searchString: state.dashboard.search.string,
  fromDate: state.dashboard.sessionsFilter.from_date,
  toDate: state.dashboard.sessionsFilter.to_date,
});

const mapDispatchToProps = (dispatch) => ({
  fetchSessions: (role, params) =>
    dispatch(actions.dashboard.sessions.fetch(role, params)),
  resetSessions: () => dispatch(actions.dashboard.sessions.reset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Lessons);
